export const selectPipelineByOwnerRankedData = (state) =>
  state.capture.pipelineByOwnerRanked.data;

export const selectPipelineByOwnerRankedLoading = (state) =>
  state.capture.pipelineByOwnerRanked.isLoading;

export const selectPipelineByOwnerRankedError = (state) =>
  state.capture.pipelineByOwnerRanked.error;

export const selectPipelineByOwnerRankedOffset = (state) =>
  state.capture.pipelineByOwnerRanked.offset;

export const selectPipelineByOwnerRankedPageSize = (state) =>
  state.capture.pipelineByOwnerRanked.pageSize;
